import { RestService } from './restService';
import { Project } from '../models/project';

export class ProjectService extends RestService<Project> {
    public constructor(baseUrl: string, baseRoute: string) {
        super(baseUrl, baseRoute);
    }
}
